import { takeLatest } from 'redux-saga/effects';
import callRequestSaga from '~/sagas/utils/request-saga';

import CompanySettingsAPI from '~/domain/company/api/company-api';
import CompanyAccountSettingsConstants from './constants';

export function* getCompanyAccount() {
  yield* callRequestSaga(CompanySettingsAPI.getCompanyAccount, {
    request: CompanyAccountSettingsConstants.GET_COMPANY_ACCOUNT_REQUEST,
    success: CompanyAccountSettingsConstants.GET_COMPANY_ACCOUNT_REQUEST_SUCCESS,
    failure: CompanyAccountSettingsConstants.GET_COMPANY_ACCOUNT_REQUEST_ERROR,
  });
}

export function* getCompanyAccountSaga() {
  yield takeLatest(CompanyAccountSettingsConstants.GET_COMPANY_ACCOUNT, getCompanyAccount);
}

export default [getCompanyAccountSaga];
